<template>
  <div class="payment-card-offer">
    <AmTypography
      class="title text--dark-3"
      :text="$t('containerLeft.cardOffer.specialOffer')"
      typography-style="l1"
      weight="bold"
    />
    <!--
      TODO: Esse trecho foi comentado pois não irá ser implementado nessa primeira versão.
     -->
    <!-- <div class="offer">
      <AmIconMaterial
        class="offer__timer"
        name="timer"
        type="outlined"
        size="lg"
      />
      <AmTypography
        :text="$t('containerLeft.cardOffer.timer', {timer: '14:15'})"
        typography-style="l3"
        weight="bold"
      />
    </div> -->

    <div class="order-bump-warning">
      <span class="order-bump-message">{{ $t('containerLeft.cardOffer.orderBumpMessage') }}</span>
      <AmHelper
        :tooltipText="tooltip.text"
        :color="tooltip.color"
        :iconName="tooltip.iconName"
      />
    </div>
    <div
      :key="orderBump.id"
      class="product"
    >
      <div class="product__icon">
        <img
          width="80"
          height="80"
          :src="imageBundleOrProductLoading(orderBump)"
          alt="package"
          loading="lazy"
        />
      </div>
      <div class="product__details">
        <AmTypography
          class="product__details__name text--dark-3"
          typography-style="l5"
        >
          <template #default>
            {{ orderBump.name }}
          </template>
        </AmTypography>
        <AmTypography
          class="product__details__price"
          typography-style="l5"
        >
          <template>
            {{ filterApplierOldPrice(orderBump) }}
          </template>
        </AmTypography>
        <AmTypography
          class="product__details__price-offer text--blue"
          typography-style="l5"
        >
          <template>
            {{ filterApplierCurrentPrice(orderBump) }}
          </template>
        </AmTypography>
      </div>
    </div>
    <AmButton
      :class="['add-cart', orderBump.added ? '' : theme.color]"
      :label="$t('containerLeft.cardOffer.addCart')"
      color="blue"
      size="xl"
      full-width
      :icon="iconAddShoppingCart"
      :disabled="orderBump.added || loadingCart"
      @click="postAddOrderBump(orderBump)"
    >
      <template
        v-if="loadingCart"
        #content
      >
        <AmLoading
          class="loading--white"
          :AmLoaderSize="25"
        />
      </template>
    </AmButton>
    <AmButton
      :class="[`purchase-finish ${theme.color}`, `button__outlined--${theme.color}`]"
      :label="finishPurchaseText"
      color="blue"
      size="xl"
      type="outlined"
      full-width
      :icon="iconShoppingBag"
      @click="continueToPaymentType()"
    />
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import loadImageBundlesMixin from '@/components/mixins/loadImageBundlesMixin'
import { mapState, mapActions, mapMutations } from 'vuex'
import queryPersistance from '@/components/mixins/queryPersistance'

export default {
  name: 'PaymentCardOffer',
  mixins: [themeMixin, currencyFilterMixin, loadImageBundlesMixin, queryPersistance],
  data() {
    return {
      iconAddShoppingCart: {
        name: 'add_shopping_cart',
        position: 'left',
        type: 'material',
        size: 'xl',
      },
      iconShoppingBag: {
        name: 'shopping_bag',
        position: 'left',
        type: 'material',
        size: 'xl',
      },
      nextDisabled: false,
      prevDisabled: true,
      tooltip: {
        text: this.$t('containerLeft.cardOffer.tooltipHelpMessage'),
        color: '#FFFFFF',
        iconName: 'help',
      },
    }
  },
  computed: {
    ...mapState('Checkout', {
      cart: (state) => state.cart,
      loadingCart: (state) => state.cartLoading,
    }),
    orderBump() {
      let bumps = this.cart.items.bundles[0]?.order_bumps
      const idsBundles = this.bundlesIds

      bumps = bumps.map((bump) => {
        if (idsBundles.includes(bump.id)) {
          return {
            ...bump,
            added: true,
          }
        }
        return bump
      })

      return bumps[0]
    },
    bundlesIds() {
      const { bundles } = this.cart.items

      const bundlesIds = bundles.map((bundle) => {
        return bundle.bundle_id
      })

      return bundlesIds
    },
    orderBumpsQuantity() {
      return this.orderBumps.length
    },
    pluralIemsOrderBumpString() {
      return this.showNavigationOffer ? 's' : ''
    },
    checkListBumpsQuantity() {
      return this.orderBumpsQuantity > 0
    },
    showNavigationOffer() {
      return this.orderBumpsQuantity > 1
    },
    checkOrderBumpExistsOnBundle() {
      return this.bundlesIds.includes(this.orderBump.id)
    },
    finishPurchaseText() {
      return this.checkOrderBumpExistsOnBundle
        ? this.$t('containerLeft.cardOffer.finishPurchase')
        : this.$t('containerLeft.cardOffer.finishPurchaseNotOffer')
    },
  },
  mounted() {
    this.SET_CURRENT_STEP(10)
  },
  methods: {
    ...mapMutations('Checkout', ['SET_CURRENT_STEP', 'SET_DISABLED_STATE_PAYMENT']),
    ...mapActions('Checkout', ['addOrderBump']),
    continueToPaymentType() {
      this.$router.push({ name: 'new.stepPayment', query: { pl: this.getPl?.pl } })
    },
    disableNextOrPrev(next, prev) {
      this.nextDisabled = JSON.parse(next.getAttribute('aria-disabled'))
      this.prevDisabled = JSON.parse(prev.getAttribute('aria-disabled'))
    },
    filterApplierOldPrice(bump) {
      return this.$t('containerLeft.cardOffer.oldPrice', {
        price: this.$options.filters.currencyBRL(bump.settings.oldPrice),
      })
    },
    filterApplierCurrentPrice(bump) {
      return this.$t('containerLeft.cardOffer.currentPrice', {
        price: this.$options.filters.currencyBRL(bump.price),
      })
    },
    async postAddOrderBump(bump) {
      try {
        await this.addOrderBump(bump.id)
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-card-offer {
  width: 100%;

  .add-cart,
  .purchase-finish {
    margin-top: 15px;
  }

  .title {
    margin: 16px auto 24px auto;
    text-align: center;
  }

  .product {
    display: flex;
    align-items: center;
    margin: 15px 0 0 0;
    @include mobile {
      margin: 15px 0 110px 0 !important;
    }
    padding: 10px;
    border: solid $dark-40 1px;
    border-radius: 0.5em;

    &__icon {
      img {
        -o-object-fit: contain;
        object-fit: contain;
      }
    }

    &__details {
      &__name,
      &__price,
      &__price-offer {
        margin-left: 16px;
        span {
          font-weight: 500;
        }
      }

      &__price {
        text-decoration: line-through;
        text-decoration-color: $dark-40;
        margin-top: 6px;
      }

      &__price-offer {
        margin-top: 3px;
      }
    }
  }

  .offer {
    display: flex;
    background: rgba($error, 0.8);
    justify-content: center;
    align-items: center;
    padding: 12px 0 12px 0;

    ::v-deep div,
    span {
      color: $white;
    }

    &__timer {
      margin-right: 11px;
    }
  }

  .quantity-offer {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
    user-select: none;

    &__navigations {
      cursor: pointer;
    }
  }

  .slider {
    ::v-deep {
      .swiper-button-next,
      .swiper-button-prev {
        background: transparent;
      }

      .swiper-button-next,
      .swiper-button-prev {
        z-index: 0;
      }

      .swiper-button-next::after,
      .swiper-button-prev::after {
        display: none;
      }

      .swiper-pagination {
        position: absolute;
        top: 125px;
        height: 30px;
      }
    }
  }

  .prev--disabled,
  .next--disabled {
    ::v-deep {
      color: $dark-40 !important;
    }
  }

  .return {
    cursor: pointer;
    margin-top: 24px;
    text-align: center;
  }

  .order-bump-warning {
    background-color: #e46f61;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 16px;
    height: 40px;
  }

  .order-bump-message {
    margin-right: 10px;
  }
}
</style>
